var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.modalShow,
          expression: "modalShow"
        }
      ]
    },
    [
      _c("div", {
        staticClass: "modal__close",
        on: {
          click: function($event) {
            _vm.closeModal()
          }
        }
      }),
      _c("div", {
        staticClass: "modal__overlay",
        on: {
          click: function($event) {
            _vm.closeModal()
          }
        }
      }),
      _c("div", { staticClass: "modal__wrapper" }, [
        _c("div", { staticClass: "modal__form modal__form--downloadTrial" }, [
          _c("div", [
            _vm._m(0),
            _c("div", { staticClass: "form__item" }, [
              _c("div", { staticClass: "form__item--title" }, [
                _c("img", {
                  staticClass: "image inline",
                  attrs: {
                    srcset:
                      "https://cdn.flixel.com/static/static-web/products/mac/icons/cinemagraph-pro-icon@2x.png" +
                      " 2x, " +
                      "https://cdn.flixel.com/static/static-web/products/mac/icons/cinemagraph-pro-icon.png" +
                      " 1x"
                  }
                }),
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.goToLink("/products/mac/cinemagraph-pro/")
                      }
                    }
                  },
                  [_c("h2", [_vm._v("Cinemagraph Pro for macOS")])]
                )
              ])
            ]),
            _c("div", { staticClass: "form__item" }, [
              _c("div", { staticClass: "form__item--title" }, [
                _c("img", {
                  staticClass: "image inline",
                  attrs: {
                    srcset:
                      "https://cdn.flixel.com/static/static-web/products/ios/icons/cinemagraph-pro-ios-icon@2x.png" +
                      " 2x, " +
                      "https://cdn.flixel.com/static/static-web/products/ios/icons/cinemagraph-pro-ios-icon.png" +
                      " 1x"
                  }
                }),
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.goToLink("/products/ios/cinemagraph-pro/")
                      }
                    }
                  },
                  [_c("h2", [_vm._v("Cinemagraph Pro for iOS")])]
                )
              ])
            ]),
            _c("div", { staticClass: "form__item" }, [
              _c("div", { staticClass: "form__item--title" }, [
                _c("img", {
                  staticClass: "image inline",
                  attrs: {
                    srcset:
                      "https://cdn.flixel.com/static/static-web/products/persecond/icons/persecond-icon@2x.png" +
                      " 2x, " +
                      "https://cdn.flixel.com/static/static-web/products/persecond/icons/persecond-icon.png" +
                      " 1x"
                  }
                }),
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.goToLink("/products/mac/persecond/")
                      }
                    }
                  },
                  [_c("h2", [_vm._v("Persecond for macOS")])]
                )
              ])
            ]),
            _c("div", { staticClass: "form__item" }, [
              _c("div", { staticClass: "form__item--title" }, [
                _c("img", {
                  staticClass: "image inline",
                  attrs: {
                    srcset:
                      "https://cdn.flixel.com/static/static-web/products/blendeo/BlendeoAppIcon@2x.png" +
                      " 2x, " +
                      "https://cdn.flixel.com/static/static-web/products/blendeo/BlendeoAppIcon@1x.png" +
                      " 1x"
                  }
                }),
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.goToLink("/products/ios/blendeo/")
                      }
                    }
                  },
                  [_c("h2", [_vm._v("Blendeo for iOS")])]
                )
              ])
            ])
          ])
        ])
      ]),
      _vm.loading ? _c("div", { staticClass: "loading--full" }) : _vm._e(),
      _vm.loading ? _c("div", { staticClass: "loading__cover" }) : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form__item" }, [
      _c("h1", [
        _vm._v(
          "Your download should begin shortly. Feel free to check any of our other products."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-284e6ee4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-284e6ee4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/downloadTrial.vue
// module id = null
// module chunks = 